import { useSessionFormState } from '@hooks/useSessionFormState';

const useIsSessionSaving = () => {
  const [isActionsSaving] = useSessionFormState('isActionsSaving', 0);
  const [isSavingNotes] = useSessionFormState('isSavingNotes', 0);
  const [isSavingDataProtection] = useSessionFormState('isSavingDataProtection', 0);

  const isSessionSavePending = !!isActionsSaving || !!isSavingNotes || !!isSavingDataProtection || false;

  return { isSessionSavePending };
};

export default useIsSessionSaving;
